import type { App } from "vue";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { createProgressGuard } from "./guards/progressGuard";
import { createPermissionGuard } from "./guards/permissionGuard";
import { createTitleGuard } from "./guards/titleGuard";

const modules: Record<string, any> = import.meta.glob("./modules/**/*.ts", {
  eager: true,
});
export const routes: RouteRecordRaw[] = [];
Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routes.push(...modList);
});

// app router
export const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export function setupRouter(app: App<Element>) {
  app.use(router);

  createProgressGuard(router);
  createPermissionGuard(router);
  createTitleGuard(router);
}
